import i18n from '@/lib/language'
export const helpConfig = {
  'OrgIndex': { title: i18n.t('message["1678"]'), videoid: 1, articleid: '5db29ef14db67f5f2049868c', tagsid: '5db69a7e4db67f209247bde6' },
  'OrgPerson': { title: i18n.t('message["931"]'), articleid: '', tagsid: '5db69a704db67f206e240e38' },
  'OrgQw': { title: i18n.t('message["720"]'), articleid: '5db2a2674db67f5f5051d265', tagsid: '5db657cf4db67f79ce148b3e' },
  'AccountInfo': { title: i18n.t('message["1571"]'), articleid: '', tagsid: '5db6a2394db67f20ad46fcdb' },
  'AccountLoginLog': { title: i18n.t('message["205"]'), articleid: '', tagsid: '5db6a2394db67f20ad46fcdb' },
  'AccountOrder': { title: i18n.t('message["246"]'), articleid: '', tagsid: '5db6a2394db67f20ad46fcdb' },
  'AccountInvoice': { title: i18n.t('message["268"]'), articleid: '', tagsid: '5db6a2394db67f20ad46fcdb' },
  'InqueryCreate': { title: i18n.t('message["622"]'), articleid: '5db661714db67f7a0d546c20', tagsid: '5db6a32e4db67f207d5f99d1' },
  'InqueryAudit': { title: i18n.t('message["1048"]'), articleid: '5db662154db67f7a057c1381', tagsid: '5db662154db67f7a057c137e' },
  'InqueryRepeat': { title: i18n.t('message["1355"]'), articleid: '5db662334db67f79da75f458', tagsid: '5db662334db67f79da75f455' },
  'InqueryDetail': { title: i18n.t('message["1378"]'), articleid: '5db663654db67f79f7229a05', tagsid: '5db663654db67f79f7229a02' },
  'InqueryList': { title: i18n.t('message["1274"]'), type: 1, allarticleid: '5db663134db67f7a066047c2', articleid: '5db662d74db67f79d00c4340', alltagsid: '5db663134db67f7a066047bf', tagsid: '5db6638c4db67f7a222164d7' },
  'quit': { title: i18n.t('message["590"]'), articleid: '5db662614db67f7a1326cf1a', tagsid: '5db6aacd4db67f20a65b16b6' },
  'smartForm': { title: i18n.t('message["1244"]'), articleid: '5db6ab4c4db67f20a836089b', tagsid: '5db6ab064db67f20a765b0ee' },
  'DataStatistic': { title: i18n.t('message["1133"]'), articleid: '5db6627e4db67f79dc7559ed', tagsid: '5db6ae8a4db67f3de6613683' },
  'DataStatisticDevelop': { title: i18n.t('message["1133"]'), articleid: '5db6627e4db67f79dc7559ed', tagsid: '5db6ae8a4db67f3de6613683' },
  'DataStatisticReception': { title: i18n.t('message["1133"]'), articleid: '5db6627e4db67f79dc7559ed', tagsid: '5db6ae8a4db67f3de6613683' },
  'DataStatisticFollow': { title: i18n.t('message["1133"]'), articleid: '5db6627e4db67f79dc7559ed', tagsid: '5db6ae8a4db67f3de6613683' },
  'DataStatisticLevel': { title: i18n.t('message["1133"]'), articleid: '5db6627e4db67f79dc7559ed', tagsid: '5db6ae8a4db67f3de6613683' },
  'CostMaintain': { title: i18n.t('message["105"]'), articleid: '5db6629d4db67f7a19329f37', tagsid: '5db6629d4db67f7a19329f34' },
  'CostMaintainDetail': { title: i18n.t('message["105"]'), articleid: '5db6629d4db67f7a19329f37', tagsid: '5db6629d4db67f7a19329f34' },
  'configCollect': { title: i18n.t('message["1173"]'), videoid: 7, articleid: '5db65ea74db67f79e62f67d8', tagsid: '5db65ea74db67f79e62f67d5' },
  'configreferrer': { title: i18n.t('message["1371"]'), videoid: 8, articleid: '5db65f134db67f79d95c1b59', tagsid: '5db65f134db67f79d95c1b56' },
  'configRelationList': { title: i18n.t('message["1365"]'), videoid: 6, articleid: '5db65f634db67f7a19329f33', tagsid: '5db65f634db67f7a19329f30' },
  'configRelationInfo': { title: i18n.t('message["1365"]'), videoid: 6, articleid: '5db65f634db67f7a19329f33', tagsid: '5db65f634db67f7a19329f30' },
  'configVisit': { title: i18n.t('message["445"]'), articleid: '5db65fa44db67f79fc23df1b', tagsid: '5db65fa44db67f79fc23df18' },
  'configSensitive': { title: i18n.t('message["645"]'), articleid: '5db660154db67f79da75f454', tagsid: '5db660154db67f79da75f451' },
  'configRepeat': { title: i18n.t('message["1357"]'), articleid: '5db65fde4db67f7a047a3ae7', tagsid: '5db65fde4db67f7a047a3ae4' },
  'RoleManagement': { title: i18n.t('message["505"]'), videoid: 3, articleid: '5db2a3244db67f5f464c862d', tagsid: '5db657c54db67f7a0c24d76a' },
  'TeamIndex': { title: i18n.t('message["1228"]'), videoid: 4, articleid: '5db2b9204db67f669f2884a3', tagsid: '5db657b64db67f7a102a729e' },
  'configNotice': { title: i18n.t('message["1218"]'), articleid: '5db660554db67f7a047a3aeb', tagsid: '5db660554db67f7a047a3ae8' },
  'configLogo': { title: i18n.t('message["1318"]') + 'logo', articleid: '5db660a94db67f7a2502f988', tagsid: '5db6a2c54db67f20852cafec' },
  'configSmart': { title: i18n.t('message["1246"]'), articleid: '', tagsid: '5db6ac9f4db67f20a4086222' },
  'ocpc': { title: 'oCPC' + i18n.t('message["1008"]'), articleid: 'd_5db660ce4db67f79e11104d8', tagsid: '5db660ce4db67f79e11104d5' },
  'setOcpc': { title: i18n.t('message["1886"]'), articleid: 'd_5db660ce4db67f79e11104d8', tagsid: '5db660ce4db67f79e11104d5' },
  'setList': { title: 'oCPC', articleid: 'd_5db660ce4db67f79e11104d8', tagsid: '5db660ce4db67f79e11104d5' },
  'ServiceSms': { title: i18n.t('message["252"]'), articleid: '5db660f14db67f7a214f7fcb', tagsid: '5db6a2c54db67f20852cafec' },
  'ServiceEmail': { title: i18n.t('message["1502"]'), articleid: '5db6610b4db67f79df1491af', tagsid: '5db6a2c54db67f20852cafec' },
  'ServiceSuper': { title: i18n.t('message["312"]'), articleid: '5db661324db67f79f42a0880', tagsid: '5db6b1b04db67f3e2766d444' },
  'ServiceBuy': { title: i18n.t('message["312"]'), articleid: '5db661324db67f79f42a0880', tagsid: '5db6b1b04db67f3e2766d444' },
  'ServiceExpasion': { title: i18n.t('message["312"]'), articleid: '5db661324db67f79f42a0880', tagsid: '5db6b1b04db67f3e2766d444' },
  'configRule': { title: i18n.t('message["1361"]'), articleid: '5dbfcf9e5c423a003029e803', tagsid: '5dbfdc694c7c5a003c6aba73' },
  // 'ServiceSms': { title: '短信充值', articleid: '5db660f14db67f7a214f7fcb', tagsid: '5db6a2c54db67f20852cafec' },
  // 'ServiceEmail': { title: '邮件充值', articleid: '5db6610b4db67f79df1491af', tagsid: '5db6a2c54db67f20852cafec' },
  // 'ServiceSuper': { title: '服务升级', articleid: '5db661324db67f79f42a0880', tagsid: '5db6b1b04db67f3e2766d444' },
  // 'ServiceBuy': { title: '服务升级', articleid: '5db661324db67f79f42a0880', tagsid: '5db6b1b04db67f3e2766d444' },
  // 'ServiceExpasion': { title: '服务升级', articleid: '5db661324db67f79f42a0880', tagsid: '5db6b1b04db67f3e2766d444' },
  // 'configRule': { title: '信息分配规则', articleid: '5dbfcf9e5c423a003029e803', tagsid: '5dbfdc694c7c5a003c6aba73' },
  DetailedList: {
    title: 'EDM',
    articleid: '5ef0801724162e00427dadfa',
    tagsid: '5ef07b7e24162e007b146520'
  },
  EmailList: {
    title: 'EDM',
    articleid: '5ef0801724162e00427dadfa',
    tagsid: '5ef07b7e24162e007b146520'
  },
  SendReport: {
    title: 'EDM',
    articleid: '5ef0801724162e00427dadfa',
    tagsid: '5ef07b7e24162e007b146520'
  },
  EditContactList: {
    title: 'EDM',
    articleid: '5ef0801724162e00427dadfa',
    tagsid: '5ef07b7e24162e007b146520'
  },
  EdmEmailEdit: {
    title: 'EDM',
    articleid: '5ef0801724162e00427dadfa',
    tagsid: '5ef07b7e24162e007b146520'
  },
  EdmEmailPrivew: {
    title: 'EDM',
    articleid: '5ef0801724162e00427dadfa',
    tagsid: '5ef07b7e24162e007b146520'
  },
  configWebhookList: {
    title: 'Webhook',
    articleid: '5ef1addaa3b66f00412c35ff',
    tagsid: '5ef19987a3b66f0072551c1a'
  },
  configAddWebhook: {
    title: 'Webhook',
    articleid: '5ef1addaa3b66f00412c35ff',
    tagsid: '5ef19987a3b66f0072551c1a'
  },
  configSendRecord: {
    title: 'Webhook',
    articleid: '5ef1addaa3b66f00412c35ff',
    tagsid: '5ef19987a3b66f0072551c1a'
  },
  InqueryClue: {
    title: '线索管理',
    articleid: '600e88c57c33ae06b5730a5f',
    tagsid: '600e88c57c33ae06b5730a5c'
  },
  ClueCreate: {
    title: '录入线索',
    articleid: '600e88c57c33ae06b5730a5f',
    tagsid: '600e88c57c33ae06b5730a5c'
  },
  configClue: {
    title: '线索配置',
    articleid: '600e88c57c33ae06b5730a5f',
    tagsid: '600e88c57c33ae06b5730a5c'
  }
}
// 拼接ifream的链接地址
// https://help.westartrack.com/page_5db79f874db67f46aa234f18.html
// ?name=%E6%96%87%E5%B8%85%E8%90%A5&videoid=3&articleid=5db2a1a34db67f5f8077a010
export const perpaerIfreamLink = (routerName, userName, from = 'my') => {
  const { articleid, tagsid, videoid, allarticleid, alltagsid } = helpConfig[routerName]
  const baseUrl = `https://help.westartrack.com/page_5db79f874db67f46aa234f18.html?name=${userName}`
  let url = ''
  if ('type' in helpConfig[routerName]) {
    if (from === 'my') {
      url = `${baseUrl}&articleid=${articleid}&tagsid=${tagsid}`
    }
    if (from === 'all') {
      url = `${baseUrl}&articleid=${allarticleid}&tagsid=${alltagsid}`
    }
  } else {
    if (videoid) {
      url = `${baseUrl}&videoid=${videoid}&articleid=${articleid}&tagsid=${tagsid}`
    } else {
      url = `${baseUrl}&articleid=${articleid}&tagsid=${tagsid}`
    }
  }
  return url
}
